import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../../../constant";
import useWebsiteInfo from "../../../../hook/useWebsiteInfo";
import { formatNumber } from "../../../../utils/formatNumber";
import { useTranslation } from "react-i18next";

/**
 * @description 入鈔限制提示彈窗
 * @param {boolean} openModal 是否開啟彈窗
 * @param {function} setOpenModal 設定是否開啟彈窗
 * @param {object} limitConfig 入鈔限制配置物件
 * @param {number} limitConfig.amount 當前入鈔金額
 * @param {number} limitConfig.limit_amount 限制入鈔金額
 * @param {function} setLimitConfig 設定入鈔限制配置物件
 * @returns JSX.Element|null 入鈔限制提示彈窗元素或 null
 */
const DepositLimitAlert = ({
  openModal,
  setOpenModal,
  limitConfig,
  setLimitConfig,
} = {}) => {
  const { t } = useTranslation();

  const { amount, limit_amount } = limitConfig || {
    amount: 0,
    limit_amount: 0,
  };
  const { images } = useWebsiteInfo();

  const handleConfirm = async () => {
    setOpenModal(false);
    setLimitConfig({ amount: 0, limit_amount: 0 });
  };

  return (
    openModal && (
      <Flex
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="rgba(0, 0, 0, 0.8)"
        zIndex="9999"
        backdropFilter="blur(2px)"
        justifyContent="center"
        alignItems="center"
      >
        <Flex
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.3 }}
          w="85%"
          maxWidth={"520px"}
          h="auto"
          maxHeight={"480px"}
          position={"relative"}
          bgImage={`url('${COMMON_WEB_PATH}/911TW/hintBG2.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          p={6}
          pt="30px"
        >
          <Flex
            fontSize="24px"
            color="white"
            textAlign="center"
            mt={4}
            bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/hintTitleBG.webp')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            sx={{ width: "-webkit-fill-available" }}
            justifyContent="center"
            alignItems="center"
            position="relative"
          >
            <Image
              src={`${COMMON_WEB_PATH}/FlyDragon/hintWORD.webp`}
              height={{
                base: "50px",
                xl: "60px",
              }}
            />
          </Flex>
          <Box
            position="relative"
            my="15px"
            mb="50px"
            fontSize="26px"
            fontWeight="black"
            color="white"
            textAlign="center"
            sx={{
              background:
                "linear-gradient(180deg, #fff 0%,#fdd26a 60%,  #b07f20 80%,  #b07f20 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0px 1px 3px rgba(255, 215, 0, 0.4)",
            }}
          >
            {t("common.您已達到入鈔限制，請聯繫客服處理")}
            <br />
            <Text fontSize="20px">
              ({t("common.當前入鈔 / 限制")}：{formatNumber(amount)} /{" "}
              {formatNumber(limit_amount)})
            </Text>
          </Box>
          <Flex
            gap={4}
            mb={4}
            justifyContent="space-between"
            alignItems="center"
          >
            <Flex
              as="button"
              w="165px"
              h="62px"
              bgImage={`url('${images.yesBTN}')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100% 100%"
              justifyContent="center"
              alignItems="center"
              onClick={handleConfirm}
              position="relative"
              zIndex={1}
            ></Flex>
          </Flex>
        </Flex>
      </Flex>
    )
  );
};

export default DepositLimitAlert;
